import {StyleSheet} from "react-native";
import {styleVars} from "../../../app-style-vars";

export const styles = StyleSheet.create({
  productDataContainer: {
    marginVertical: styleVars.rem(.5),
    padding: styleVars.rem(.5),
    backgroundColor: styleVars.boschLightGrayW75,
  },
  lineItemHeader: {
    paddingBottom: styleVars.rem(.25),
    borderBottomWidth: 1,
    borderBottomColor: styleVars.boschDarkBlue,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  lineItemNumber: {},
  lineItemNumberText: {
    fontSize: styleVars.rem(.875),
  },
  lineItemStatus: {},
  deliveryDetailsContainer: {},
  componentsContainer: {},
  componentsContainerHeader: {},
  componentsContainerHeaderText: {
    fontSize: styleVars.rem(.875),
    color: styleVars.boschDarkBlue,
    fontWeight: '600',
  },
  componentsFlyout: {
  },
  sectionContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingVertical: styleVars.rem(.125),
  },
  sectionRow: {
    width: '100%'
  },
  sectionLabel: {
    maxWidth: '45%',
  },
  sectionLabelText: {
    fontSize: styleVars.rem(.875),
    fontWeight: '600',
  },
  sectionValue: {
    maxWidth: '50%',
  },
  sectionValueText: {
    fontSize: styleVars.rem(.875),
    textAlign: 'right',
  },
  bold: {
    fontWeight: '600',
  }
});